import { useIntl } from '@services/i18n';
import { useApi } from '@/.shared/.api/integration';
import { toastError } from '../services/notification-service';

const api = useApi();
const intl = useIntl();

export async function descargarZipFicherosMedida(idFicheroMedida: number) : Promise<void> {
    // try {    
        const apiCallChain = await api.prepareStandardApi("ficheroMedidaDownloadZip")(idFicheroMedida);
        const href = `${apiCallChain.axiosInstance.defaults.baseURL!}${apiCallChain.axiosConfiguration.url}`;
        window.location.href = href;
    // } catch (error) {    
    //     toastError(intl.i18n.t('ficheros_medida.descarga_zip.mensaje_error'));
    //     console.error(error);
    // }
}